import React, { useEffect } from "react";
import { Stack, Typography } from "@mui/material";
import dayjs from "dayjs";

import { HubHookFormInput, InputLabel } from "../../components";
import AddWorkOrderRepeat from "./AddWorkOrderRepeat";
import AddWorkOrderRepeatCustom from "./AddWorkOrderRepeatCustom";
import AddWorkOrderEndDate from "./AddWorkOrderEndDate";
import { StyledDisabledDatePicker } from "./styles";
import { useFormContext } from "react-hook-form";
import AddWorkOrderTesting from "./AddWorkOrderTesting";

const inputSx = {
  padding: "10px 15px",
  border: "1px solid",
  borderColor: "hubColors.greyLight",
  borderRadius: "7px",
  height: "35.81px",
  justifyContent: "center",
  backgroundColor: "hubColors.greyLighter",
};

const AddWorkOrderForm = ({
  totalDays = 0,
  partsPerTree = 1,
  customerDueDate,
  orderQuantity = 1,
}) => {
  const dueDate = dayjs(customerDueDate).format("MM/DD/YYYY");
  const { setValue, watch } = useFormContext();

  const onUpdateQuantity = (_, qty) => {
    const value = Number(qty) || partsPerTree;
    const trees = Math.ceil(value / partsPerTree);
    const patReq = trees * partsPerTree;

    setValue("quantity", patReq);
    setValue("trees", trees);
  };

  const onUpdateTrees = (_, trees) => {
    const value = Number(trees) || 1;
    const patReq = value * partsPerTree;

    setValue("quantity", patReq);
    setValue("trees", value);
  };

  const quantity = watch("quantity");
  const estimatedCompleted = watch("estimatedCompleted");

  useEffect(() => {
    setValue("estimatedCompleted", Number(quantity) || 0);
  }, [quantity, setValue]);

  useEffect(() => {
    const exp = Number(estimatedCompleted);
    const qty = Number(quantity) || 0;
    if (Number.isFinite(exp) && exp > qty) {
      setValue("estimatedCompleted", qty);
    }
  }, [estimatedCompleted, quantity, setValue]);

  return (
    <Stack gap="15px">
      <Stack direction="row" gap="5px">
        <HubHookFormInput
          name="trees"
          label="Batch Trees"
          required
          isNumber
          defaultValue={1}
          onBlur={onUpdateTrees}
        />
        <HubHookFormInput
          name="quantity"
          label="Batch Quantity"
          required
          isNumber
          defaultValue={partsPerTree}
          onBlur={onUpdateQuantity}
        />
        <HubHookFormInput
          name="batches"
          label="# of Batches"
          required
          isNumber
          defaultValue={1}
        />
      </Stack>
      <AddWorkOrderRepeat />
      <AddWorkOrderRepeatCustom />
      <Stack direction="row" gap="5px">
        <StyledDisabledDatePicker
          name="customerDueDate"
          label="Customer Due Date"
          defaultValue={dueDate}
          disabled
        />
        {!!totalDays && <AddWorkOrderEndDate totalDays={totalDays} />}
        <Stack width="100%">
          <InputLabel label="Customer Ordered" />
          <Stack sx={inputSx}>
            <Typography variant="caption">{orderQuantity}</Typography>
          </Stack>
        </Stack>
        <HubHookFormInput
          name="estimatedCompleted"
          label="Estimated Completed"
          required
          isNumber
          defaultValue={orderQuantity}
        />
      </Stack>
      <AddWorkOrderTesting />
    </Stack>
  );
};

export default AddWorkOrderForm;
